module.exports = __webpack_public_path__ + "img/itomanman_comic06.8d76dd0a.jpg";